import { useKeyboard } from '@/common/utils/keyboardController';

const DIALOG_CONTENT_SELECTOR = '.el-dialog__container';

type DialogComponent = {
  $refs: { dialog?: { handleClose: () => void, closeOnPressEscape?: boolean } };
};

const componentIds = new WeakMap<DialogComponent, number>();
let nextComponentId = 0;

const contextName = (component: DialogComponent): string => {
  if (!componentIds.has(component)) {
    componentIds.set(component, nextComponentId += 1);
  }
  return `dialog:${componentIds.get(component)}`;
};

const onEscape = (component: DialogComponent) => (event: KeyboardEvent): boolean => {
  const { dialog } = component.$refs;
  const target = event.target as Element | null;
  if (dialog && dialog.closeOnPressEscape !== false && !target?.closest?.(DIALOG_CONTENT_SELECTOR)) {
    dialog.handleClose();
  }
  return true;
};

export const registerDialogEscape = (component: DialogComponent): void => {
  const { keyboard } = useKeyboard();
  keyboard.registerHandlers(contextName(component), {
    handlers: { Escape: onEscape(component) },
    phase: 'bubble'
  });
};

export const unregisterDialogEscape = (component: DialogComponent): void => {
  const { keyboard } = useKeyboard();
  keyboard.unregister(contextName(component));
};
